<template>
  <!-- TODO: Rename to baseLayout-->
  <DefaultLayout v-if="showProjectDetail" name="DefaultLayout">
    <vue-headful :title="getPageTitle('Project Detail')" />
    <template>
      <HeroBar :class="$style.projectDetailPageContainer">
        <b-tooltip
          v-if="projectSettingInfo.name.length > 50"
          :label="projectSettingInfo.name"
          multilined
          position="is-right"
          :class="$style.tooltipTitle"
        >
          {{ projectSettingInfo.name.substring(0, 50) + '...' }}
        </b-tooltip>
        <span v-else :class="$style.projectTitle">{{
          projectSettingInfo.name
        }}</span>
      </HeroBar>

      <article
        class="tile notification bg-primary-light p1"
        v-if="isProjectArchived"
      >
        <small>{{ message }}</small>
      </article>

      <b-tabs
        :animated="false"
        :class="$style.tabLabel"
        v-model="activeTab"
        class="dashboard-tabs"
      >
        <b-tab-item label="DASHBOARD">
          <ProjectDashboardTab
            v-if="
              !isLoading && isUserProjectOwnerOrCoordinator && projectDetail
            "
            @changeActiveTab="changeActiveTab"
            :key="dashboardTabKey"
            :editable="editable"
            :isProjectOwner="isProjectOwner"
            :isUserProjectOwnerOrCoordinator="isUserProjectOwnerOrCoordinator"
          />
        </b-tab-item>

        <b-tab-item label="CRITERIA">
          <ProjectCriteriaTab
            v-if="
              !isLoading && isUserProjectOwnerOrCoordinator && projectDetail
            "
            :key="criteriaTabKey"
            :projectId="projectId"
            :projectDetail="projectDetail"
            :editable="editable"
            :isUserProjectOwnerOrCoordinator="isUserProjectOwnerOrCoordinator"
          ></ProjectCriteriaTab>
        </b-tab-item>

        <b-tab-item :class="$style.tabItem" label="PARTICIPANTS">
          <ParticipantTab
            v-if="isUserProjectOwnerOrCoordinator"
            :key="participantsTabKey"
            :editable="editable"
            :projectOwner="projectOwner"
          />
        </b-tab-item>

        <b-tab-item :class="$style.tabItem" label="GRIP">
          <GripTab
            v-if="
              !isLoading && activeTab === getTabIndex('#grip') && projectDetail
            "
            :editable="editable"
            :projectId="projectId"
            :projectDetail="projectDetail"
            @changeActiveTab="changeActiveTab"
            :key="gripTabKey"
          >
          </GripTab>
        </b-tab-item>

        <b-tab-item :class="$style.tabItem" label="REPORTS">
          <ProjectReportsTab
            v-if="isUserProjectOwnerOrCoordinator"
            :editable="editable"
            :key="reportTabKey"
          ></ProjectReportsTab>
        </b-tab-item>
        <b-tab-item label="SETTINGS">
          <div :class="$style.settingTabItem">
            <ProjectSettingsTab
              v-if="
                !isLoading && isUserProjectOwnerOrCoordinator && projectDetail
              "
              :key="settingTabKey"
              :projectId="projectId"
              :projectDetail="projectDetail"
              :projectSettingInfo="projectSettingInfo"
              :isProjectOwner="isProjectOwner"
              :activeTab="activeSettingsTab"
              @updateProjectSettings="updateProjectSettingInfo"
              @updatedProjectStatus="handleUpdatedProjectStatus"
              @active-vertical-tab-index-changed="handleActiveSettingsTabChange"
            ></ProjectSettingsTab>
          </div>
        </b-tab-item>
        <b-tab-item label="ACTIVITY LOG">
          <div :class="$style.activityLogContainer">
            <ProjectEventLogs
              v-if="
                !isLoading && isUserProjectOwnerOrCoordinator && projectDetail
              "
              :key="activityLogTabKey"
              :projectDetail="projectDetail"
              :projectId="projectId"
            ></ProjectEventLogs>
          </div>
        </b-tab-item>
      </b-tabs>
    </template>
  </DefaultLayout>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import DefaultLayout from '../../layouts/DefaultLayout.vue';
import HeroBar from '@/components/base/HeroBar.vue';
import { Action, State } from 'vuex-class';
import {
  ProjectDetailPayload,
  ProjectSettingResponsePayload,
  ProjectStatus,
  RecurrenceSettingPayload,
  UserEntity,
  UserRoleInProject,
} from '@/store/modules/projects/types/projects.types';
import dayjs from 'dayjs';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@/utils/date.util';
import { last as _last, isEqual as _isEqual } from 'lodash';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import AuditCard from '@/views/Project/components/AuditCard.vue';
import AuditList from '@/views/Project/components/AuditList.vue';
import ProjectDashboardTab from '@/views/Project/tabs/ProjectDashboardTab.vue';
import ProjectCriteriaTab from '@/views/Project/tabs/ProjectCriteriaTab.vue';
import ParticipantTab from '@/views/Project/tabs/ParticipantTab.vue';
import ProjectReportsTab from '@/views/Project/tabs/ProjectReportsTab.vue';
import ProjectEventLogs from '@/views/Project/components/ProjectEventLogs.vue';
import { useUserEmail } from '@/utils/user.util';
import ProjectSettingsTab from '@/views/Project/tabs/ProjectSettingsTab.vue';
import GripTab from '../Grip/GripTab.vue';
import { handleErrorResponse } from '@/utils/api-response-error-handler.util';

/**
 * Declaration of available tabs in the page
 */
const tabNames = [
  '#dashboard',
  '#criteria',
  '#participants',
  '#grip',
  '#report',
  '#settings',
  '#activityLog',
];

@Component({
  components: {
    ProjectEventLogs,
    AuditList,
    AuditCard,
    DefaultLayout,
    HeroBar,
    ParticipantTab,
    ProjectDashboardTab,
    ProjectCriteriaTab,
    ProjectReportsTab,
    ProjectSettingsTab,
    GripTab,
  },
})
export default class ProjectDetailPage extends Vue {
  public activeTab: number = 0;
  public activeSettingsTab: number = 0;
  // public projectExpiry: any = null;
  public recurrenceSetting!: RecurrenceSettingPayload;
  // public initialValue: any = {};
  // public isSettingSubmitButtonDisabled: boolean = true;
  public isGeneralSettingSubmitButtonDisabled: boolean = true;
  public deletedCriteriaList: number[] = [];
  public projectOwner: UserEntity | null = null;
  public projectSettingInfo: any = {
    name: '',
    description: '',
    enableProjectGrip: true,
  };

  public isProjectArchived: boolean = false;
  public showProjectDetail: boolean = false;
  public criteriaTabKey: number = Math.floor(Math.random() * 999);
  public dashboardTabKey: number = Math.floor(Math.random() * 999);
  public participantsTabKey: number = Math.floor(Math.random() * 999);
  public reportTabKey: number = Math.floor(Math.random() * 999);
  public gripTabKey: number = Math.floor(Math.random() * 999);
  public activityLogTabKey: number = Math.floor(Math.random() * 999);
  public settingTabKey: number = Math.floor(Math.random() * 999);
  public isLoading: boolean = true;

  public handleActiveSettingsTabChange(newIndex: number): void {
    if (this.activeSettingsTab !== newIndex) {
      this.activeSettingsTab = newIndex;
    }
  }

  @Action('projects/getProjectDetail')
  public getProjectDetail!: (projectId: number) => void;

  @State((state) => state.projects.projectDetail)
  public projectDetail!: ProjectDetailPayload;

  @State((state) => state.projects.apiState.getProjectDetail.success)
  public getProjectDetailApiStateSuccess!: boolean;

  @Action('projects/getUpdatedProjectReportJBICriteriaList')
  public getUpdatedProjectReportJBICriteriaList!: (projectId: number) => void;

  @Watch('getProjectDetailApiStateSuccess')
  @isTruthy
  public watchGetProjectDetailSuccess() {
    if (this.projectDetail.status === ProjectStatus.DRAFT) {
      this.$router.push({
        name: 'project-me',
        query: {
          tab: 'Draft',
        },
      });
    }
    if (
      this.projectDetail.status === ProjectStatus.DELETED ||
      !this.userEmail
    ) {
      this.$router.push({
        name: 'project-me',
      });
      return;
    }
    if (!this.isUserProjectOwnerOrCoordinator) {
      handleErrorResponse({ response: { status: 403 } }, this);
    }

    this.projectSettingInfo = {
      name: this.projectDetail.title,
      description: this.projectDetail.description,
      enableProjectGrip: this.projectDetail.enableProjectGrip,
    };
    this.changeActiveTabBasedOnUrl(); // Sets initial activeTab
    this.projectOwner = this.projectDetail.user;
    this.isLoading = false;
    this.isProjectArchived = Boolean(
      this.projectDetail.status === ProjectStatus.ARCHIVED,
    );
  }

  public handleUpdatedProjectStatus(status: ProjectStatus) {
    this.isProjectArchived = Boolean(status === ProjectStatus.ARCHIVED);
  }

  public updateProjectSettingInfo(newValue: any): void {
    this.projectSettingInfo = {
      name: newValue.title,
      description: newValue.description,
      enableProjectGrip: newValue.enableProjectGrip,
    };
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  /**
   * Extract tab change logic into a reusable method.
   *
   * This method updates the route hash and triggers data loading from the new tab.
   * This logic was originally inside the tabChange method.
   *
   * @param {number} tabIndex  - The index of the tab to switch to
   */
  private updateRouteAndLoadData(tabIndex: number): void {
    // Indicate that the page is now in loading state
    this.isLoading = true;

    // Re-fetch the main project details. This ensures that any data displayed within any tab is based on the most current project information.
    this.getProjectDetail(this.projectId);

    /**
     * Determine the target URL hash string based on the new tab index. `tabNames` is an array like ['#dashboard', '#criteria', etc...]
     * so tabNames[tabIndex] gives the hash string (e.g. '#dashboard') for the selected tab
     */
    const targetHash = tabNames[tabIndex];

    /**
     * Only attempt to change the URL's hash if the targetHash for the new tab is actually different from the current URL's hash (`this.$route.hash`).
     * If they are the same (e.g. on initial page load where the URL already contains the target hash), calling `this.$router.replace` would be redundant.
     */
    if (this.$route.hash !== targetHash) {
      /**
       * Replace the URL's hash with the target hash.
       * `replace` is being used instead of `push` to avoid adding a new entry to browser's history.
       *
       */
      this.$router.replace({ hash: targetHash });
    }

    // this.$router.replace({ hash: tabNames[tabIndex] });
    if (tabNames[tabIndex] === '#report') {
      this.getUpdatedProjectReportJBICriteriaList(this.projectId);
    }
    this.renderTabComponent(true);
  }

  public getTabIndex(value: string): number {
    return tabNames.findIndex((tab) => tab === value);
  }

  public renderTabComponent(updateKey: boolean = false) {
    // The primary role of this function is now to update keys for forced re-renders.
    // Visibility is handled by b-tabs and v-if conditions in the template.
    const currentTabName = tabNames[this.activeTab];

    switch (currentTabName) {
      case '#dashboard':
        if (updateKey) this.dashboardTabKey += 1;
        break;
      case '#criteria':
        if (updateKey) this.criteriaTabKey += 1;
        break;
      case '#participants':
        if (updateKey) this.participantsTabKey += 1;
        break;
      case '#grip':
        // The v-if for GripTab in the template already checks: activeTab === getTabIndex('#grip')
        // So, no specific showGripTab flag is needed here.
        if (updateKey) this.gripTabKey += 1;
        break;
      case '#report':
        if (updateKey) this.reportTabKey += 1;
        break;
      case '#settings':
        if (updateKey) this.settingTabKey += 1;
        break;
      case '#activityLog':
        if (updateKey) this.activityLogTabKey += 1;
        break;
      default:
        // This default case handles invalid hashes or ensures a default tab.
        // If currentRouteHash is not a recognized tab, set to the first tab.
        if (this.currentRouteHash !== tabNames[0] && this.activeTab !== 0) {
          // Check activeTab to prevent loop if already 0
          this.activeTab = 0;
          // Update the route hash to reflect the change to the default tab.
          // This will also re-trigger the tab guard if the hash changes.
          if (this.$route.hash !== tabNames[this.activeTab]) {
            this.$router.replace({ hash: tabNames[this.activeTab] });
          }
        } else if (this.activeTab === 0 && updateKey) {
          // If default tab is dashboard and key update is requested
          this.dashboardTabKey += 1;
        }
        break;
    }
  }

  // public transformSettings(settings: ProjectSettingResponsePayload) {
  //   const currentActiveSetting: ProjectSettingResponsePayload = settings;
  //   this.projectExpiry = new Date(currentActiveSetting.expiryDate);
  //   this.recurrenceSetting = {
  //     recurrenceType: currentActiveSetting.recurrenceType,
  //     scheduledRecurrenceStartDate:
  //       currentActiveSetting.scheduledRecurrenceStartDate,
  //     scheduledRecurrenceEndDate:
  //       currentActiveSetting.scheduledRecurrenceEndDate,
  //     multipleRecurrenceType: currentActiveSetting.multipleRecurrenceType,
  //     enableGrip: currentActiveSetting.auditNumber,
  //     auditSamplingType: currentActiveSettings,
  //     interval,
  //     auditNumber,
  //     dataCollectionPeriodSettings,
  //   };
  //   this.initialValue.currentActiveSetting = currentActiveSetting;
  //   this.initialValue.projectExpiry = this.projectExpiry;
  //   this.initialValue.recurrenceSetting = this.recurrenceSetting;
  // }

  @Watch('activeTab')
  public onActiveTabChange(newTabIndex: number, oldTabIndex: number): void {
    if (newTabIndex !== oldTabIndex && !this.isLoading) {
      // Check !this.isLoading to prevent re-triggering during initial load sequence
      // or during the data loading phase initiated by updateRouteAndLoadData itself.
      this.updateRouteAndLoadData(newTabIndex);
    }
  }

  public mounted(): void {
    this.getProjectDetail(this.projectId);
    this.showProjectDetail = true;
  }

  public changeActiveTabBasedOnUrl() {
    let hashId: string = this.currentRouteHash;
    let targetHorizontalTabIndex = -1;

    if (this.currentRouteHash.startsWith('#settings')) {
      hashId = '#settings'; // Main horizontal tab is "SETTINGS".
      // Current behavior: activeSettingsTab (for vertical tab in ProjectSettingsTab)
      // is NOT set from a sub-path like '#settings-barrier' on initial load here.
      // ProjectSettingsTab will receive the current value of this.activeSettingsTab (default 0)
      // and display its corresponding vertical tab.
      // If ProjectSettingsTab internally changes its vertical tab, it emits an event,
      // and handleActiveSettingsTabChange updates this.activeSettingsTab.
    }

    targetHorizontalTabIndex = tabNames.findIndex((value) => value === hashId);

    const newActiveTab =
      targetHorizontalTabIndex !== -1 ? targetHorizontalTabIndex : 0;

    if (this.activeTab !== newActiveTab) {
      this.activeTab = newActiveTab; // This will trigger the watcher in useTabChangeGuard if it's a different tab
      // However, useTabChangeGuard is for *user-initiated* changes.
      // For programmatic changes like this, we might not want the guard's full "unsaved changes" dialog.
      // But since this is on load, isModalActive should be false.
    }

    // Ensure the component for the determined activeTab is rendered and its key potentially updated.
    // Pass false for updateKey as this is initial setup; data loading is handled by updateRouteAndLoadData
    // or specific data fetches triggered by tab activation.
    // updateRouteAndLoadData will be called if the tab change is confirmed by the guard,
    // or directly if no guard is triggered.
    // Here, we just ensure the correct tab content is made visible initially.
    this.renderTabComponent(false); // Call with false, as key updates are for re-triggers.
    // The initial load of data is handled by getProjectDetail and potentially updateRouteAndLoadData.
  }

  public formatDate(s: string) {
    return dayjs(s).format(DATE_FORMAT);
  }

  public formatDateTime(s: string) {
    return dayjs(s).format(DATE_TIME_FORMAT);
  }

  get currentRouteHash() {
    return this.$route.hash;
  }

  get projectId(): number {
    return +this.$route.params.projectId;
  }

  get projectStatus() {
    return this.projectDetail ? this.projectDetail.status : '';
  }

  get editable() {
    return !Boolean(this.projectStatus === 'Archived');
  }

  get message() {
    return 'Archived projects period cannot be edited';
  }

  get isProjectOwner(): boolean {
    if (this.projectDetail) {
      return this.projectDetail.user.oicPayload.email === this.userEmail
        ? true
        : false;
    }
    return false;
  }

  get isProjectCoordinator(): boolean {
    if (this.projectDetail && this.projectDetail.userRoleInProject) {
      const coordinator =
        this.projectDetail.userRoleInProject ===
        UserRoleInProject.isProjectCoOrdinator;

      return coordinator ? true : false;
    }
    return false;
  }

  get isUserProjectOwnerOrCoordinator(): boolean {
    if (this.userEmail && this.projectDetail) {
      return this.isProjectOwner || this.isProjectCoordinator;
    }
    return false;
  }

  public getCurrentProjectSetting(project: ProjectDetailPayload) {
    return _last(project.settings) as ProjectSettingResponsePayload;
  }

  // @Watch('projectExpiry')
  // @isTruthy
  // @isDifferentDeep
  // public watchProjectExpiry(newValue: any) {
  //   if (!_isEqual(this.initialValue.projectExpiry, newValue)) {
  //     this.isSettingSubmitButtonDisabled = false;
  //   }
  // }

  public changeActiveTab(newValue: string) {
    const targetIndex = Object.values(tabNames).findIndex(
      (value) => value === newValue,
    );

    if (targetIndex !== -1 && targetIndex !== this.activeTab) {
      // Manually trigger the watcher logic by attempting to set the activeTab
      this.activeTab = targetIndex;
    } else if (targetIndex !== -1 && targetIndex === this.activeTab) {
      this.updateRouteAndLoadData(this.activeTab);
    }
  }
}
</script>
<style lang="scss" module>
.tabItem {
  padding-top: 42px;
}
.settingTabItem {
  padding-top: 22px;
}
.startAuditBtn {
  border-radius: 290486px;
}
.newAuditCard {
  background-color: #21b5ea;
  border-radius: 4px;
  width: 280px;
  height: 280px;
  padding: 15px;
  color: #ffffff;
  font-size: 24px;
  font-weight: 400;
}
.auditCardTitle {
  color: #fff;
}
.rightBorder {
  border-right: 1px solid #d3e9fa;
}
.detailContainer {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
}
.projectTitle {
  color: #00205b;
  font-size: 40px;
  font-weight: 700;
  font-family: Oswald;
  width: 100%;
  display: inline flow-root;
  height: 35px;
  padding-top: 5px;
}
.tooltipTitle {
  font-family: Oswald;
  font-size: 40px;
  font-weight: 700;
  color: #00205b;
  &::after {
    font-family: 'Open Sans';
  }
}
.selectJbiCriteriaBtn,
.selectJbiCriteriaBtn:hover,
.selectJbiCriteriaBtn.is-hovered,
.selectJbiCriteriaBtn:active {
  background-color: #00205b;
  border-radius: 4px;
  height: 64px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}
.addCustomCriteriaBtn,
.addCustomCriteriaBtn:hover,
.addCustomCriteriaBtn.is-hovered,
.addCustomCriteriaBtn:active {
  background-color: #21b5ea;
  border-radius: 4px;
  height: 64px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}
.jbiImage {
  vertical-align: middle;
  padding-right: 1rem;
}
.saveChangesBtn {
  float: right;
  border-radius: 24px;
  height: 48px;
  padding: 0 calc(1em + 0.25em);
  font-weight: 700 !important;
  font-size: 18px !important;
  line-height: 22px !important;
}
.projectParticipantEditContainer {
  padding: 0rem 11rem;
}
.projectSettingsEditContainer {
  width: 680px;
  margin-right: auto;
  margin-left: 20px;
}
.tabLabel {
  margin: 0rem 0rem;
}

.tabLabel .tabs ul li {
  margin-right: 60px;
}
.tabLabel nav li a {
  color: #9f9f9f;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  padding-left: 0px;
  padding-right: 0px;
}
.tabLabel nav li a:hover {
  color: #00205b;
}
.reportContainer {
  text-align: center;
  vertical-align: middle;
  height: 100%;
}
.evidenceContainer {
  text-align: center;
  vertical-align: middle;
  height: 100%;
}
.activityLogContainer {
  vertical-align: middle;
  height: 100%;
}
.reportMessage {
  line-height: 22;
  color: #9f9f9f;
  font-size: 18px;
  font-weight: 700;
}
.addItem {
  color: #21b5ea;
  font-weight: 400;
  margin-bottom: 60px;
}
.projectDetailPageContainer {
  margin-top: 2rem;
  div {
    width: 100%;
  }
  h1 {
    width: 100%;
  }
}
.tabItem {
  padding-top: 42px;
}
</style>
